module.exports = __webpack_public_path__ + "static/img/logo_sj.5d5024b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo_sj.png
// module id = YUK8
// module chunks = 1